import * as types from './types';
import { BookingToursService } from '../../services/tours/tours.service';
import { requestCancellationErrorHandler, REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { HttpLib } from '../../../../services/http/http-lib';
import { createHttpGetOptions } from '../../../../services/http/http-client';
import { validateResponse } from '../../../../services/http/response-validator';

let getContactsFormPromoterTokenSource = null;

export const bookingToursActions = {
    async [types.BOOKING_TOURS.FETCH.ALL]({ commit }, payload) {
   
      const tourData = await BookingToursService.getToursData();
      console.log("TOUR DATA ",tourData.data);

    },
  
  
  };